import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";

dayjs.extend(utc);
dayjs.extend(timezone);

createRoot(document.getElementById("root")!).render(
  // <Suspense fallback={<div>Loading...</div>}>
  <App />,
  // </Suspense>,
);

serviceWorker.unregister();
